module.exports = __webpack_public_path__ + "static/media/video3.ae77235.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video3.mp4
// module id = 2WfQ
// module chunks = 1